import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { logoutUser } from '../../../store/request/loginRequest';
import { useNavigate } from 'react-router-dom';
//import { fetchUserProfile } from '../../store/request/fetchUserProfile';

const useDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.auth.userData);
    const token = useSelector((state) => state.auth.token);
    const handleLogout = () => {
        dispatch(logoutUser());
    };

    useEffect(() => {
        
        // const fetchData = async () => {
        //     const data = await fetchUserProfile();
        //     setUserData(data);
        // };

        // if (userInfo) {
        //     fetchData();
        // }

        if (!token) {
            navigate('/login', { replace: true });
        }
    
    }, [userInfo, token, navigate]);

    return { userInfo, handleLogout };
};

export default useDashboard;
